<!-- Progress idicator -->
<div id="overlay" [ngStyle]="{'display': isLoading ? 'block' : 'none' }">
    <mat-progress-spinner class="custom-spinner" mode="indeterminate" value=25 [diameter]="65"></mat-progress-spinner>
</div>
<div class="login-page" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlexFill>
    <div class="page-container" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
        <div class="login-dialog-container" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="500px">
            <!-- Dialog header -->
            <div class="login-dialog-container-header" fxLayoutAlign="start center" fxFlex="45px">Welcome!</div>
            <!-- Dialog body -->
            <div class="login-dialog-container-body" fxLayout="column" style="position: relative;"
                fxLayoutAlign="start stretch" fxFlex>
                <!-- Forgot User ID overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': hiddenUserIdPanelPosition}" fxLayout="column"
                    fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideForgotUserIdPanelAction()"></fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Forgot User ID</div>
                    </div>
                    <!-- Overlay body -->
                    <div fxLayoutAlign="center stretch" fxFlex>
                        <!-- Left side -->
                        <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                            <div style="margin-right: 25px;" fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                <form id="forgot-user-id-form" fxLayout="column" fxLayoutAlign="start center"
                                    [formGroup]="forgotUserIdFormGroup" (ngSubmit)="onForgotUserId()" fxFlex>
                                    <div fxLayoutAlign="center start" fxFlex>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex>
                                            <input id="forgot-user-id-panel" matInput
                                                formControlName="forgotUserIdFormControl" placeholder="Account Number"
                                                required>
                                            <mat-error
                                                *ngIf="forgotUserIdFormHasError('forgotUserIdFormControl', 'required')">
                                                Account number required.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </form>
                                <div class="landing-pane-footer" fxLayout="column" fxLayoutAlign="end stretch" fxFlex>
                                    <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="40px">
                                        <button form="forgot-user-id-form" mat-stroked-button class="reset-button"
                                            [disabled]="forgotUserIdFormGroup.invalid" type="submit" fxFlex>Email
                                            Me</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Divider -->
                        <div style="height: 100%;" fxLayout="column" fxLayoutAlign="center center" fxFlex="1px">
                            <div class="panel-divider" fxFlex="250px">
                            </div>
                        </div>
                        <!-- right side -->
                        <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                            <fa-icon [icon]="['fas', 'key']" size="4x" fxFlex="35px">
                            </fa-icon>
                            <div style="padding-top: 55px;" fxFlex>
                                <p>
                                    Enter your account number in the field on the left<br> and click the button at the
                                    bottom of the <br> panel to have your User ID emailed to your<br> email address of
                                    record.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Forgot Password overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': hiddenPasswordPanelPosition}" fxLayout="column"
                    fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideForgotPasswordPanelAction()"></fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Forgot Password</div>
                    </div>
                    <!-- Overlay body -->
                    <div fxLayoutAlign="center stretch" fxFlex>
                        <!-- Left side -->
                        <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                            <div style="margin-right: 25px;" fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                <form id="forgot-password-form-id" fxLayout="column" spellcheck="false"
                                    fxLayoutAlign="start center" [formGroup]="resetPasswordFormGroup"
                                    (ngSubmit)="onForgotPassword()">
                                    <div fxLayoutAlign="center start" fxFlex>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex>
                                            <input id="user-id-field" matInput
                                                formControlName="passwordResetFormControl" placeholder="User ID"
                                                required>
                                            <mat-error
                                                *ngIf="resetFormHasError('passwordResetFormControl', 'required')">
                                                User ID required.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="resetFormHasError('passwordResetFormControl', 'maxlength')">
                                                Too many characters.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </form>
                                <div class="landing-pane-footer" fxLayout="column" fxLayoutAlign="end stretch" fxFlex>
                                    <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="40px">
                                        <button form="forgot-password-form-id" mat-stroked-button class="reset-button"
                                            [disabled]="resetPasswordFormGroup.invalid" type="submit" fxFlex>Email
                                            Me</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Divider -->
                        <div style="height: 100%;" fxLayout="column" fxLayoutAlign="center center" fxFlex="1px">
                            <div class="panel-divider" fxFlex="250px">
                            </div>
                        </div>
                        <!-- right side -->
                        <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                            <fa-icon [icon]="['fas', 'key']" size="4x" fxFlex="35px">
                            </fa-icon>
                            <div style="padding-top: 55px;" fxFlex>
                                <p>
                                    Enter your User ID in the field on the left and<br> click the button at the
                                    bottom of the <br> panel to have a new password emailed to your<br> email address of
                                    record.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Failed login overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': failedLoginPanelPosition}" fxLayout="column"
                    fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideLoginFailedPanelAction()"></fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Login Failed</div>
                    </div>
                    <!-- Overlay body -->
                    <div class="failed-login-body-wrapper" fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex>
                            <fa-icon [icon]="['fas', 'exclamation-circle' ]" size="3x"
                                [styles]="{'stroke-width': '5','stroke': 'red', 'color': 'red'}"
                                (click)="onHideLoginFailedPanelAction()"></fa-icon>
                            <div fxFlex>
                                <p>
                                    Unfortunately, your login attempt failed. Click the OK button below and re-enter
                                    your credentials.
                                </p>
                                <p>
                                    Note that if you do not successfully log in within three attempts, online access
                                    to your account will be disabled. If you believe this has occurred
                                    or if you need additional assistance, please contact your Account Representative
                                    or email us at support@monex.com.
                                </p>
                            </div>
                        </div>
                        <div fxLayoutAlign="center center" fxFlex="40px">
                            <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="265px">
                                <button id="faildLoginPanelButton" mat-stroked-button class="reset-button" (click)="onHideLoginFailedPanelAction()"
                                    fxFlex>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Failed Setup overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': failedSetupPanelPosition}" fxLayout="column"
                    fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideSetupFailedPanelAction()"></fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Setup Failed</div>
                    </div>
                    <!-- Overlay body -->
                    <div class="failed-login-body-wrapper" fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex>
                            <fa-icon [icon]="['fas', 'exclamation-circle' ]" size="3x"
                                [styles]="{'stroke-width': '5','stroke': 'red', 'color': 'red'}"
                                (click)="onHideSetupFailedPanelAction()"></fa-icon>
                            <p>
                                Unfortunately, your setup attempt failed. Click the OK button below and re-enter your
                                credentials.
                                For further assistance, please contact your Account Representative or email us at
                                support@monex.com.
                            </p>
                        </div>
                        <div fxLayoutAlign="center center" fxFlex="40px">
                            <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="265px">
                                <button mat-stroked-button class="reset-button" (click)="onHideSetupFailedPanelAction()"
                                    fxFlex>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Access disabled overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': accountAccessDisabledPanelPosition}"
                    fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideAccountAccessDisabledPanelAction()">
                        </fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Account Access Disabled</div>
                    </div>
                    <!-- Overlay body -->
                    <div class="failed-login-body-wrapper" fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex>
                            <fa-icon [icon]="['fas', 'exclamation-circle' ]" size="3x"
                                [styles]="{'stroke-width': '5','stroke': 'red', 'color': 'red'}"
                                (click)="onHideAccountAccessDisabledPanelAction()"></fa-icon>
                            <p>
                                Unfortunately, access to your account has been disabled. An email has been sent to you
                                with
                                instructions as to how to re-enable your account for online access. </p>
                            <p>
                                For further assistance, please contact your Account Representative or email us at
                                support@monex.com.
                            </p>
                        </div>
                        <div fxLayoutAlign="center center" fxFlex="40px">
                            <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="265px">
                                <button mat-stroked-button class="reset-button"
                                    (click)="onHideAccountAccessDisabledPanelAction()" fxFlex>OK</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Temporary password expired overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': temporaryPasswordExpiredPanelPosition}"
                    fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideTemporaryPasswordExpiredPanelAction()">
                        </fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Temporary Password Expired</div>
                    </div>
                    <!-- Overlay body -->
                    <div class="failed-login-body-wrapper" fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex>
                            <fa-icon [icon]="['fas', 'exclamation-circle' ]" size="3x"
                                [styles]="{'stroke-width': '5','stroke': 'red', 'color': 'red'}"
                                (click)="onHideTemporaryPasswordExpiredPanelAction()"></fa-icon>
                            <p>
                                Unfortunately, your temporary password has expired.  To have a new temporary password 
                                mailed to you, please click the OK button and then the Forgot Password button on the Login
                                panel.
                             </p>
                            <p>
                                For further assistance, please contact your Account Representative or email us at
                                support@monex.com.
                            </p>
                        </div>
                        <div fxLayoutAlign="center center" fxFlex="40px">
                            <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="265px">
                                <button mat-stroked-button class="reset-button"
                                    (click)="onHideTemporaryPasswordExpiredPanelAction()" fxFlex>OK</button>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Action succeeded overlay -->
                <div class="dialog-body-overlay" [ngStyle]="{ 'height': actionSucceededPanelPosition}" fxLayout="column"
                    fxLayoutAlign="start stretch" fxFlex>
                    <div class="dropdown-header" fxLayoutAlign="start center" fxFlex="55px">
                        <fa-icon [icon]="['fas', 'chevron-up' ]" (click)="onHideActionSucceededPanelAction()">
                        </fa-icon>
                        <div fxLayoutAlign="center center" fxFlex>Success!</div>
                    </div>
                    <!-- Overlay body -->
                    <div class="failed-login-body-wrapper" fxLayout="column"
                        fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px" fxFlex>
                            <div fxLayoutAlign="center center" fxFlex="60px"><img src="/assets/images/success-checkmark.svg"
                                    alt="Successful save!">
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start start" fxFlex>
                                <div fxLayout="column" fxLayoutAlign="center start" fxFlex=100px>
                                    <p>
                                        Your requested information has been emailed to your address of record.
                                    </p>                              
                                    <p>
                                        For additional assistance, please contact your Account Representative or email us at
                                        support@monex.com.
                                    </p>    
                                </div>                                                               
                            </div>
                        </div>
                        <div fxLayoutAlign="center center" fxFlex="40px">
                            <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="265px">
                                <button mat-stroked-button class="reset-button"
                                    (click)="onHideActionSucceededPanelAction()" fxFlex>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Static Login tabbed panel. -->
                <mat-tab-group mat-align-tabs="center" (selectedTabChange)="onTabChanged($event);">
                    <mat-tab label="Log In" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                        <div fxLayoutAlign="center start" fxLayoutGap="25px" fxFlexFill fxFlex>
                            <div class="login-split-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                <form id="landing-form-id" class="input-form landing-form" spellcheck="false"
                                    fxLayout="column" fxLayoutAlign="start center" [formGroup]="loginFormGroup"
                                    (ngSubmit)="onLogin()" fxFlex>
                                    <mat-form-field class="user-id-field" appearance="outline">
                                        <input id="landing-user-id-field" matInput formControlName="userIdFormControl"
                                            placeholder="User Id" required>
                                        <mat-error *ngIf="landingFormHasError('userIdFormControl', 'required')">User ID
                                            is
                                            required
                                        </mat-error>
                                        <mat-error *ngIf="landingFormHasError('userIdFormControl', 'maxlength')">You
                                            have more
                                            than 45
                                            characters
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="password-field" appearance="outline" fxFlex>
                                        <input matInput [type]="passwordFieldHide ? 'password' : 'text'"
                                            formControlName="passwordFormControl" placeholder="Password" required>
                                        <fa-icon matSuffix (click)="passwordFieldHide = !passwordFieldHide"
                                            [icon]="passwordFieldHide ? ['fas', 'eye' ]: ['fas', 'eye-slash' ]">
                                        </fa-icon>
                                        <mat-error *ngIf="landingFormHasError('passwordFormControl', 'required')">
                                            Password is
                                            required
                                        </mat-error>
                                        <mat-error *ngIf="landingFormHasError('passwordFormControl', 'maxlength')">You
                                            have
                                            more
                                            than
                                            45
                                            characters
                                        </mat-error>
                                    </mat-form-field>
                                </form>
                                <div class="landing-pane-footer" fxLayout="column" fxLayoutAlign="end stretch"
                                    fxLayoutGap="5px" fxFlex>
                                    <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="40px">
                                        <button id="landing-go-button" mat-stroked-button class="green-action-button"
                                            type="submit" form="landing-form-id" [disabled]="loginFormGroup.invalid"
                                            fxLayoutAlign="center center" fxFlex>
                                            <fa-icon [icon]="['fas', 'sign-in-alt']" size="lg" fxFlex="25px">
                                            </fa-icon>
                                            <span class="button-text">Log In</span>
                                        </button>
                                    </div>
                                    <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="40px">
                                        <button mat-stroked-button class="forgotPasswordButton"
                                            (click)="onShowForgotUserIdPanelAction()">Forgot User ID</button>
                                    </div>
                                    <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="40px">
                                        <button mat-stroked-button class="forgotPasswordButton"
                                            (click)="onShowForgotPasswordPanelAction()">Forgot Password</button>

                                    </div>
                                </div>
                            </div>
                            <div style="height: 100%;" fxLayout="column" fxLayoutAlign="center center" fxFlex="1px">
                                <div class="panel-divider" fxFlex="250px">
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                <fa-icon [icon]="['fas', 'sign-in-alt']" [styles]="{'stroke': '#3a4469', 'color': '#3a4469'}" size="4x" fxFlex="35px">
                                </fa-icon>
                                <div style="padding-top: 55px; padding-right: 25px;" fxFlex>
                                    <p>
                                        Establish Online Access
                                    </p>
                                    <p>
                                        Click the Set Up tab above to activate your Monex Atlas account. Online
                                        access allows you to securely view your account status and download
                                        statements, confirmations, and year-end summaries.
                                    </p>
                                    <p>
                                        Need help? Contact your Account Representative for personalized support.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Set Up" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                        <div style="background-color: transparent; border-radius: 0px 0px 5px 5px;"
                            fxLayoutAlign="center start" fxLayoutGap="25px" fxFlexFill fxFlex>
                            <div class="login-split-panel" style="height: 100%; border-radius: 0px 0px 5px 5px;"
                                fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                                <form id="setup-form-id" fxLayout="column" fxLayoutAlign="start center"
                                    [formGroup]="setupFormGroup" (ngSubmit)="onSetup()" fxFlex>
                                    <mat-form-field class="user-name-field" style="border-top: 0px;"
                                        appearance="outline" fxFlex>
                                        <input id="account-number-field" matInput formControlName="accountFormControl"
                                            placeholder="{{field1PlaceholderText}}">
                                        <mat-error *ngIf="setupHasError('accountFormControl', 'required')">Account
                                            number is
                                            required
                                        </mat-error>
                                        <mat-error *ngIf="setupHasError('accountFormControl', 'maxlength')">You have
                                            more
                                            than 9
                                            characters
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="password-field" appearance="outline" fxFlex>
                                        <input matInput formControlName="ssnFormControl"
                                            placeholder="{{field2PlaceholderText}}">
                                        <mat-error *ngIf="setupHasError('ssnFormControl', 'required')">Last 4 digits of
                                            your
                                            SSN
                                            is
                                            required
                                        </mat-error>
                                        <mat-error *ngIf="setupHasError('ssnFormControl', 'maxlength')">You have more
                                            than 4
                                            characters
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="password-field" appearance="outline" fxFlex>
                                        <input matInput formControlName="emailFormControl"
                                            placeholder="{{field3PlaceholderText}}">
                                        <mat-error *ngIf="setupHasError('emailFormControl', 'required')">Email address
                                            is
                                            required
                                        </mat-error>
                                        <mat-error *ngIf="setupHasError('emailFormControl', 'maxlength')">You have more
                                            than
                                            8
                                            characters
                                        </mat-error>
                                    </mat-form-field>
                                </form>
                                <div class="landing-pane-footer" fxLayout="column" fxLayoutAlign="end stretch"
                                    fxLayoutGap="5px" fxFlex>
                                    <div fxLayoutAlign="center stretch" flex>
                                        <div class="button-wrapper" fxLayoutAlign="center center" fxFlex="230px">
                                            <button id="landing-go-button" mat-stroked-button
                                                class="green-action-button" type="submit" form="setup-form-id"
                                                [ngClass]="(setupFormGroup.invalid)?'disabled-button':'enabled-button'"
                                                [disabled]="setupFormGroup.invalid">Set Up</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 100%;" fxLayout="column" fxLayoutAlign="center center" fxFlex="1px">
                                <div class="panel-divider" fxFlex="250px">
                                </div>
                            </div>
                            <div style="background-color: transparent; height: 100%; border-radius: 0px 0px 5px 5px;"
                                fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                <fa-icon [icon]="['fas', 'user-cog']" [styles]="{'stroke': '#3a4469', 'color': '#3a4469'}" size="4x" fxFlex="35px"></fa-icon>
                                <div style="padding-top: 55px;" fxFlex>
                                    <p>
                                        Setting Up Your Online Access
                                    </p>
                                    <p>
                                        Establishing online access to your account is a straightforward process. Simply enter the required details
                                        and click Set Up. Once your information is verified, we will email your new login credentials to you immediately.
                                    </p>                                   
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>